export default __webpack_public_path__ + "static/wenjun-e8cf78c5382a721d7ad1d96b2e8e3318.jpg";